export const items = [
    { label: "Transfers In", value: "/transfers/transfers-prepak/prepak-in" },
    { label: "Transfers Out", value: "/transfers/transfers-prepak/prepak-out" },
]
